import { Icon } from 'copilot-design-system';
import { useTranslation } from 'react-i18next';
import {
  FiEdit as EditIcon,
  FiNavigation as NavigationIcon,
} from 'react-icons/fi';

import { DetailsIcon, TrashIcon } from 'src/components/icons';
import { Action, BaseActionsMenuButton } from 'src/legacy/components/Dropdowns';

import { ClientActionsRendererProps } from './types';

export const ClientActionRenderer = ({
  data,
  handleClickRemove,
  handleClickEdit,
  handleClickInvite,
  handleClickCopyAccessLink,
  handleClickEmailAccessLink,
  handleClickViewDetails,
  onActionMenuClick,
}: ClientActionsRendererProps) => {
  const { t } = useTranslation();
  const actions: Action[] = [
    {
      name: 'Edit info',
      icon: <EditIcon />,
      onClick: () => handleClickEdit(data),
    },
  ];
  if (data.status !== 'Active' && handleClickInvite) {
    actions.push({
      name: `${
        data.status === 'Inactive' ? 'Send invite' : 'Invite client'
      }...`,
      onClick: () => handleClickInvite(data),
      icon: <NavigationIcon />,
    });
  }

  if (handleClickEmailAccessLink) {
    actions.push({
      name: `Email magic link`,
      onClick: () => handleClickEmailAccessLink(data),
      icon: <Icon icon="Invite" className="h-4 w-4 text-gray-small" />,
    });
  }
  if (handleClickCopyAccessLink) {
    actions.push({
      name: `Copy magic link`,
      onClick: () => handleClickCopyAccessLink(data),
      icon: <Icon icon="Copy" className="h-4 w-4 text-gray-small" />,
    });
  }

  if (handleClickViewDetails) {
    actions.unshift({
      name: 'View details',
      icon: <DetailsIcon />,
      onClick: () => handleClickViewDetails(data),
    });
  }
  actions.push({
    name: t(($) => $.actions.delete_client),
    onClick: () => handleClickRemove(data),
    icon: <TrashIcon />,
    isDelete: true,
  });

  return (
    <BaseActionsMenuButton
      onActionMenuClick={onActionMenuClick}
      actions={actions}
    />
  );
};
